import gql from 'graphql-tag'

export const GET_DATABRICKS_DASHBOARD_EMBED_CONFIG = gql`
  query GetDatabricksDashboardEmbedConfig {
    databricksDashboardEmbedConfig {
      isSuccessful
      errorCode
      errorName
      message
      status
      databricksDashboardEmbedConfig {
        workspaceUrl
        workspaceId
        dashboardId
        embedToken
        expiresIn
      }
    }
  }
`
